import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar-dark bg-primary justify-content-between mb-4 px-4" }
const _hoisted_2 = { class: "w-75 mx-auto navbar" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("者也专栏")
const _hoisted_4 = {
  key: 0,
  class: "list-inline mb-0"
}
const _hoisted_5 = { class: "list-inline-item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登陆")
const _hoisted_7 = { class: "list-inline-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("注册")
const _hoisted_9 = {
  key: 1,
  class: "list-inline mb-0"
}
const _hoisted_10 = { class: "list-inline-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("新建文章")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("我的专栏")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑资料")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (!_ctx.user.isLogin)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/login",
                class: "btn btn-outline-light my-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/signup",
                class: "btn btn-outline-light my-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_dropdown, {
                title: `你好 ${_ctx.user.nickName}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_dropdown_item, { closeAfterClick: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: "/create",
                        class: "dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dropdown_item, { closeAfterClick: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: `/column/${_ctx.user.column}`,
                        class: "dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dropdown_item, { closeAfterClick: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: "/edit",
                        class: "dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dropdown_item, { closeAfterClick: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: "#",
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
                      }, "退出登陆")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]))
    ])
  ]))
}